<!--
 * @Description: qa mobile
 * @Author:  单珊珊
 * @Date: 2024-07-24 10:52:41
 * @LastEditTime: 2024-09-06 09:50:16
 * @LastEditors:  
-->
<template>
  <div class="mobile-container">
    <page-header>{{'常见问题' | dealLanguage('FAQ')}}</page-header>
    <van-tabs scrollspy sticky title-inactive-color="#999" title-active-color="#333" offset-top="1.22rem">
      <van-tab v-for="item in qa_list" :title="item.title" :key="item.id">
        <div class="qa-wrapper">
          <div class="q-title">Q：{{item.title | dealLanguage(item.enTitle)}}</div>
          <div class="a-content" v-html="item.summary" v-if="language == 'zh'"></div>
          <div class="a-content" v-html="item.enSummary" v-else></div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import PageHeader from '@/components/mobile/pageHeader.vue'
import { mapState } from 'vuex'
import { detailcontent } from '@/service/vbef'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? '常见问题' : 'FAQ',
    }
  },
  inject: ['wxShare'],
  data() {
    return {
      qa_list: [],
    }
  },

  components: {
    PageHeader,
  },

  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
      user_key: (state) => state.user_key,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
    }),
  },

  created() {
    this.detailcontent()
  },

  mounted() {
    this.wxShare({
      title: filter.dealLanguage('常见问题-2025VB100大会', 'FAQ-2025VB100 Conference'),
      linkurl: this.vbef_path + '/qa',
      
    })
  },

  methods: {
    async detailcontent() {
      let res = await detailcontent({
        actId: this.activityId,
        modeNames: ['faq'],
      })
      if (res.code == 0) {
        this.$set(this.$data, 'qa_list', res.data.faq)
      } else {
        this.$Messager.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
.mobile-container
  >>>.van-tabs__nav--line
    padding 0 0.4rem
    .van-tab
      margin-right 0.28rem
      padding-bottom 0.12rem
      &.van-tab--active
        position relative
        &::before
          content ''
          position absolute
          bottom 0.17rem
          width 100%
          border-bottom 0.02rem solid #4e77df
    .van-tabs__line
      width 0
      height 0
  .qa-wrapper
    .q-title
      width 100%
      background #80A4FF
      font-size 0.28rem
      color #FFFFFF
      line-height 0.4rem
      text-align justify
      padding 0.2rem 0.4rem
    >>>.a-content
      padding 0.2rem 0.4rem 0.3rem
      font-size 0.3rem
      color #3D3D3D
      line-height 0.56rem
      text-align justify
      ol
        list-style auto
        padding-left 0.2rem
        li
          list-style auto
      ul
        list-style disc
        padding-left 0.2rem
        li
          list-style disc
      a
        color #2d7bc5
      em
        font-style italic
      img
        margin 0 auto
        display block
        max-width 100% !important
        max-height 100% !important
      span
        max-width 100% !important
        padding 0
      p
        max-width 100% !important
        margin 0
        // font-weight 500
        color #1D2129
        line-height 0.56rem
        text-align justify
      table
        width 100%
        td
          border 1px solid #e5e5e5
      iframe
        width 100% !important
        height 2rem !important
      section
        max-width 100% !important
        p
          margin inherit
          font-size inherit
          font-weight inherit
          color inherit
          line-height inherit
          text-align inherit
      video
        max-width 100% !important
        max-height 6rem !important
        background #000
      .toastui-editor-ww-code-block-highlighting
        overflow auto
        max-width 100% !important
</style>